import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgTableComponent } from '@nttp/table/component/ng-table.component';
import { CSVElementToIncludeArray, CSVElementsToIncludeDefaultSelected } from '@pg-app/shared/constants/csv-elements-to-include-constants';

@Component({
  selector: 'np-csv-elements-to-include-client-statement',
  templateUrl: './csv-elements-to-include-client-statement.component.html',
  styleUrls: ['./csv-elements-to-include-client-statement.component.scss']
})
export class CsvElementsToIncludeClientStatementComponent implements OnInit {
  @ViewChild("csvElementsToIncludeTable") csvElementsToIncludeTable: NgTableComponent;
  csvElementsToIncludeColumns = [
    {
      title: 'Name',
      name: 'name',
      width: '370px',
      hiddenFilter: true,
    },
  ];
  csvElementsToIncludeRows: any[] = CSVElementToIncludeArray;
  invalidSelected = false;

  constructor(private fb: FormBuilder, 
    public dialogRef: MatDialogRef<CsvElementsToIncludeClientStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.csvElementsToIncludeRows.forEach(s => {
      if (CSVElementsToIncludeDefaultSelected.includes(s.id)) {
        s.checked = true;
      }
    })
  }

  download() {
    const selected = this.csvElementsToIncludeRows.filter(x => x.checked).map(x => x.id);
    if (selected.length) {
      this.dialogRef.close(selected);
    } else {
      this.invalidSelected = true;
    }
  }

  selectItem() {
    const selected = this.csvElementsToIncludeRows.filter(x => x.checked).map(x => x.id);
    if (!selected.length) {
      this.invalidSelected = true;
    } else {
      this.invalidSelected = false;
    }
  }
}
